import React from "react";
import { Box } from "@chakra-ui/react";
import { IUnderlyingsInTextData } from "src/api/server/news.types";
import { ParagraphWithMentions } from "./paragraph-with-mentions/paragraph-with-mentions";

const MIN_PARAGRAPH_CHARACTERS = 200;

// Helper function to determine when to inject the component
const getIndexToInject = ({ paragraphs }: { paragraphs: string[] }) => {
    if (paragraphs.length === 1) {
        return 0;
    }

    let charactersCount = 0;
    for (let i = 0; i < paragraphs.length; i++) {
        charactersCount += paragraphs[i].length;
        if (charactersCount >= MIN_PARAGRAPH_CHARACTERS) {
            return i;
        }
    }

    return paragraphs.length;
};

interface IParagraphsWithInjectedContentProps {
    paragraphs: string[];
    ComponentToInject: React.ReactNode | null;
    underlyingsInTextData: IUnderlyingsInTextData[];
}

export const ParagraphsWithInjectedContent = ({ paragraphs, underlyingsInTextData, ComponentToInject }: IParagraphsWithInjectedContentProps) => {
    const indexToInject = ComponentToInject ? getIndexToInject({ paragraphs }) : 0;

    return (
        <>
            {paragraphs.map((paragraph, index) => {
                return (
                    <React.Fragment key={index}>
                        <Box role="paragraph" mb={index === paragraphs.length - 1 ? [3, 4] : [2, 4]}>
                            {underlyingsInTextData.length === 0 ? (
                                <Box dangerouslySetInnerHTML={{ __html: paragraph }} />
                            ) : (
                                <ParagraphWithMentions underlyingsInTextData={underlyingsInTextData} paragraph={paragraph} />
                            )}
                        </Box>

                        {indexToInject === index && ComponentToInject ? <Box mb={[2, 4]}>{ComponentToInject}</Box> : null}
                    </React.Fragment>
                );
            })}
        </>
    );
};
